import React from 'react';
import type { IntegrationActivityEvent } from 'src/api/generated';
import type { PropertyPortalPublication } from 'src/api/generated';
import { ActivitySection } from 'src/modules/shared/components/molecules/activity-section';
import type { TranslateParams } from 'src/modules/shared/types/i18n/i18n.type';
import type { TranslationKey } from 'src/modules/shared/types/i18n/translation-keys.type';
import { PropertyPublicationHistory } from './property-publication-history';
import { PropertyPublicationAlerts } from './property-publication-alerts';
import type { PropertyPublicationAlert } from '../../utils/property-publication-alert.util';
import { resolvePropertyPublicationProblemMessage } from '../../utils/property-publication-error.util';

interface PropertyMeliPublicationStatusSectionProps {
  alerts: PropertyPublicationAlert[];
  currentPublication: PropertyPortalPublication | null;
  publicationEvents: IntegrationActivityEvent[];
  t: (key: TranslationKey, params?: TranslateParams) => string;
}

export const PropertyMeliPublicationStatusSection: React.FC<
  PropertyMeliPublicationStatusSectionProps
> = ({ alerts, currentPublication, publicationEvents, t }) => {
  const resolvedLastErrorMessage = resolvePropertyPublicationProblemMessage({
    code: currentPublication?.lastErrorCode,
    message: currentPublication?.lastErrorMessage,
    t,
  });
  const extraProblemMessages = resolvedLastErrorMessage
    ? [resolvedLastErrorMessage]
    : [];

  return (
    <div className="space-y-4 border-t border-slate-200 pt-4">
      {extraProblemMessages.length > 0 ? (
        <PropertyPublicationAlerts
          alerts={alerts}
          extraMessages={extraProblemMessages}
        />
      ) : null}

      {extraProblemMessages.length === 0 && alerts.length > 0 ? (
        <PropertyPublicationAlerts alerts={alerts} />
      ) : null}

      {currentPublication ? (
        <ActivitySection contentClassName="max-h-72">
          <PropertyPublicationHistory
            publication={currentPublication}
            events={publicationEvents}
          />
        </ActivitySection>
      ) : null}
    </div>
  );
};
